import React from 'react';
import { RiCheckFill } from '@remixicon/react';
import styles from './CustomCheckBox.module.css';

export interface CheckBoxProps {
  isChecked?: boolean;
  isDisabled?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  'aria-label'?: string;
  id?: string;
  name?: string;
  value?: string;
}

const CheckBox: React.FC<CheckBoxProps> = ({
  isChecked = false,
  isDisabled = false,
  onChange,
  className = '',
  'aria-label': ariaLabel,
  id,
  name,
  value,
}) => {
  const handleClick = () => {
    if (!isDisabled && onChange) {
      onChange(!isChecked);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      handleClick();
    }
  };

  const getCheckBoxClass = () => {
    if (isDisabled) {
      return `${styles.checkbox} ${styles['checkbox--disabled']}`;
    }
    if (isChecked) {
      return `${styles.checkbox} ${styles['checkbox--checked']}`;
    }
    return `${styles.checkbox} ${styles['checkbox--default']}`;
  };

  return (
    <div
      className={`${getCheckBoxClass()} ${className}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role='checkbox'
      aria-checked={isChecked}
      aria-disabled={isDisabled}
      aria-label={ariaLabel}
      tabIndex={isDisabled ? -1 : 0}
      id={id}
      data-name={name}
      data-value={value}
    >
      {(isChecked || isDisabled) && (
        <RiCheckFill size={16} color={isDisabled ? '#A1A1AA' : '#FFFFFF'} />
      )}
    </div>
  );
};

CheckBox.displayName = 'CheckBox';

export default CheckBox;
